import { useState } from 'react';
import Button from './Button.js';
import Alert from './Alert.js';

const DeliverGcModal = ({ isOpen, onClose, onSubmit, loading = false }) => {
  const [value, setValue] = useState('');
  if (!isOpen) return null;

  const submit = (event) => {
    event.preventDefault();
    const id = value.trim();
    if (!id) {
      Alert.error('Enter a GC or consignment number');
      return;
    }
    onSubmit(id);
  };

  return (
    <div
      className="fixed inset-0 z-[90] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
      data-app-modal="true"
      onClick={onClose}
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-4"
      >
        <h2 className="text-lg font-semibold text-gray-900">Deliver shipment</h2>
        <p className="text-sm text-gray-500">
          Enter GC or consignment number. Update Status will open with Delivered selected — it will not save until you confirm.
        </p>
        <input
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="GC / consignment no"
          className="w-full px-3 py-2 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="primary" loading={loading}>Open Delivered</Button>
        </div>
      </form>
    </div>
  );
};

export default DeliverGcModal;
